import { Power0, Power3 } from 'gsap'
import TimelineMax from 'gsap/TimelineMax'
import { bindInViewTimelineStagger } from '../util/animations'

class ProductListed {
  constructor ($el, masterTimeline) {
    this.$el = $el
    this.d = $el.width() / 800
    if (typeof $el.data('animateIn') === 'undefined' || $el.data('animateIn') === true) {
      this.timelineIn = new TimelineMax({ paused: true, onComplete: () => { this.$el.data('animateInDone', true) } })
      this.buildTimelineIn()
      bindInViewTimelineStagger($el, this.timelineIn, masterTimeline)
    }
    this.timelineHover = new TimelineMax({ paused: true })

    console.log(window.isTouch)

    if (window.isTouch) {
      return
    }

    this.buildTimelineHover()
  }

  buildTimelineIn () {
    this.timelineIn
      .fromTo(
        this.$el.find('.product-listed__image'),
        this.d,
        { x: '-100%' },
        { x: '0%', ease: Power3.easeInOut },
        0
      )
      .fromTo(
        this.$el.find('.bg'),
        this.d,
        { x: '100%' },
        { x: '0%', ease: Power3.easeInOut },
        0
      )

    if (window.isTouch) {
      const $hover = this.$el.find('.product-listed__hover')

      this.timelineIn
        .set(
          $hover,
          { autoAlpha: 1 },
          0
        )
        .fromTo(
          $hover.find('.cover'),
          0.4,
          { opacity: 0 },
          {
            opacity: 1,
            ease: Power0.easeNone,
          },
          0
        )
        .staggerFromTo(
          $hover.find('.meta').children(),
          0.4,
          {
            y: '20px',
            autoAlpha: 0,
          },
          {
            y: '0px',
            autoAlpha: 1,
            ease: Power3.easeInOut,
          },
          0.1,
          0.05
        )
    }
  }

  buildTimelineHover () {
    const $el = this.$el
    const $hover = $el.find('.product-listed__hover')
    this.timelineHover
      .set(
        $hover,
        { autoAlpha: 1 }
      )
      .fromTo(
        $hover.find('.cover'),
        0.4,
        { opacity: 0 },
        {
          opacity: 1,
          ease: Power0.easeNone,
        },
        0
      )
      .staggerFromTo(
        $hover.find('.meta').children(),
        0.4,
        {
          y: '20px',
          autoAlpha: 0,
        },
        {
          y: '0px',
          autoAlpha: 1,
          ease: Power3.easeInOut,
        },
        0.1,
        0.05
      )

    $el.data('timelineHover', this.timelineHover)
  }
}

export default ProductListed



// WEBPACK FOOTER //
// ./scripts/components/ProductListed.js